import React from 'react';
import { UserIcon } from '@heroicons/react/24/outline';
import { AnsweredBy } from '../../pages/PublicChatWidget';



interface ChatModeToggleProps {
  mode: AnsweredBy;
  onChange: (mode: AnsweredBy) => void;
}

export const ChatModeToggle: React.FC<ChatModeToggleProps> = ({ mode, onChange }) => {
  const isBot = mode === 'bot';
  const isStaff = mode === 'staff';

  return (
    <div className="flex items-center gap-2 text-xs font-medium">
      <span className="mr-1 text-black/80">Reply as</span>
      <div className="inline-flex rounded-full bg-white border border-black/20 px-0.5 py-0.5 shadow-sm">
        <button
          type="button"
          onClick={() => onChange(AnsweredBy.BOT)}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-all duration-150
            ${
              isBot
                ? 'bg-black text-white shadow-sm'
                : 'text-black/60 hover:bg-black/5'
            }`}
        >
          Bot
        </button>
        <button
          type="button"
          onClick={() => onChange(AnsweredBy.STAFF)}
          className={`px-3 py-1 rounded-full flex items-center gap-1 text-xs font-semibold transition-all duration-150
            ${
              isStaff
                ? 'bg-black text-white shadow-sm'
                : 'text-black/60 hover:bg-black/5'
            }`}
        >
          <UserIcon className="h-3.5 w-3.5" />
          Staff
        </button>
      </div>
    </div>
  );
};

